import { Component, Input, OnInit } from '@angular/core';

function mod(a: number, n: number): number {
    return a - Math.floor(a / n) * n;
}

@Component({
    selector: 'app-compass',
    templateUrl: './compass.component.html',
    styleUrls: ['./compass.component.scss']
})
export class CompassComponent implements OnInit {

    directionRotationValue: string;
    northRotationValue: string;
    rotationValue: string;

    private _direction: number;
    private _north: number;

    constructor() {
    }


    get direction(): number {
        return this._direction;
    }

    @Input()
    set direction(value: number) {

        if (isNaN(value)) {
            return;
        }

        this._direction = value || 0;
        this.directionRotationValue = `rotate(${this.direction - 45}deg)`;
    }

    get north(): number {
        return this._north;
    }

    @Input()
    set north(value: number) {
        if (isNaN(value)) {
            return;
        }

        this._north = value || 0;
        this.northRotationValue = `rotateZ(${this.north}deg)`;
    }

    ngOnInit() {
    }
}
